(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tweedekans-product-offers"] && !Shopify.designMode) return;
  try {
    (() => {
    const placeOffers = () => {
      document.querySelectorAll('.product__info-container .tk-offers').forEach((offer) => {
        const info = offer.closest('.product__info-container');
        const button = info.querySelector('.ses-capacity-configurator__add');
        if (button && button.getClientRects().length && button.nextElementSibling !== offer) {
          button.insertAdjacentElement('afterend', offer);
        }
      });
    };
    const schedule = () => {
      placeOffers();
      let attempts = 0;
      const timer = window.setInterval(() => {
        placeOffers();
        if (++attempts >= 20) window.clearInterval(timer);
      }, 150);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule, { once: true });
    } else {
      schedule();
    }
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
  })();
  } catch(e) { console.error(e); }
})();

})();
